<template>
    <div name="genetic" class="genetic">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'genetic'
}
</script>

<style scoped>
    .genetic {
        padding-left: 10px;
        padding-right: 10px;;
    }
</style>


// WEBPACK FOOTER //
// src/pages/genetic/Genetic.vue